<!-- 加载编辑器的容器 -->
<!-- <div [id]="'r_' + config.name" #editerDom> </div> -->
<!-- <input type="hidden" ngDefaultControl #firstnameControl="ngModel" [name]="config.name" [(ngModel)]="config.value" /> -->
<app-g-ueditor ngDefaultControl #firstnameControl="ngModel" [name]="config.name" [(ngModel)]="config.value"></app-g-ueditor>
